import { Components, Theme } from "@mui/material";

export const SelectStyle = (
  theme: Theme
): Pick<Components, "MuiSelect" | "MuiOutlinedInput" | "MuiList"> => {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          height: "53px",
          boxSizing: "border-box",
          minWidth: "30px",
          backgroundColor: "#222222",
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#363636",
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#222222",
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#363636",
          },
        },
      },
    },

    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: "#222222",
        },
      },
    },
  };
};
